exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(true);
// imports


// module
exports.push([module.id, ".map-container--3bDP3{position:relative;border-radius:8px;padding:0 !important;overflow:hidden}.location-item--1F6a6{position:absolute;bottom:16px;left:16px;color:white;z-index:99;background-position:left;background-repeat:no-repeat}\n", "", {"version":3,"sources":["/workspace/src/widget/new-event-layouts/shared/map-container/styles.scss"],"names":[],"mappings":"AAAA,sBACE,kBACA,kBACA,qBACA,eAAgB,CACjB,sBAGC,kBACA,YACA,UACA,YACA,WACA,yBACA,2BAA4B,CAAA","file":"styles.scss","sourcesContent":[".map-container {\n  position: relative;\n  border-radius: 8px;\n  padding: 0 !important;\n  overflow: hidden;\n}\n\n.location-item {\n  position: absolute;\n  bottom: 16px;\n  left: 16px;\n  color: white;\n  z-index: 99;\n  background-position: left;\n  background-repeat: no-repeat;\n}\n"],"sourceRoot":""}]);

// exports
exports.locals = {
	"map-container": "map-container--3bDP3",
	"mapContainer": "map-container--3bDP3",
	"location-item": "location-item--1F6a6",
	"locationItem": "location-item--1F6a6"
};